<div class="wrapper" [ngClass]="{'small': isImageSmall, 'no-padding': isImageBig}" >

        <div class="row ion-justify-content-between" *ngIf="this.imagePath && this.text ">
            <div class="image ion-col-2">
                <img [src]="'/assets/images' + this.imagePath" alt="not study history yet">

            </div>
            <div  class="text ion-align-self-center">
                {{ this.text | transloco}}


            </div>
        </div>

</div>
